import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { CustomerRecord } from '../entities/records';
import * as selectors from '../entities/Customer/selectors';

function mapStateToProps(state, { customerId }) {
  return {
    customer: selectors.customerById(state, customerId),
  };
}

export default compose(
  setPropTypes({
    customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    customer: PropTypes.instanceOf(CustomerRecord),
  }),
)(mapStateToProps);
